// src/formatCurrency.ts
var AmountFormat = /* @__PURE__ */ ((AmountFormat2) => {
  AmountFormat2["Short"] = "short";
  AmountFormat2["Card"] = "card";
  AmountFormat2["Whole"] = "whole";
  AmountFormat2["Long"] = "long";
  return AmountFormat2;
})(AmountFormat || {});
var COMPACT_UNITS = [
  [1e12, "T"],
  [1e9, "B"],
  [1e6, "M"],
  [1e3, "K"]
];
var compactNumber = (num) => {
  const abs = Math.abs(num);
  if (abs < 1e3) return String(Math.round(num));
  for (const [factor, suffix] of COMPACT_UNITS) {
    if (abs < factor) continue;
    const scaled = num / factor;
    const digits = Math.abs(scaled) < 10 ? 1 : 0;
    return `${scaled.toFixed(digits).replace(/\.0$/, "")}${suffix}`;
  }
  return String(Math.round(num));
};
var compactCardNumber = (abs) => {
  const units = [...COMPACT_UNITS, [1, ""]];
  for (let i = 0; i < units.length; i++) {
    const [factor, suffix] = units[i];
    if (abs < factor && factor !== 1) continue;
    const scaled = abs / factor;
    const digits = factor === 1 ? 0 : scaled < 100 ? 1 : 0;
    const rounded = Math.round(scaled * 10 ** digits) / 10 ** digits;
    if (rounded >= 1e3 && i > 0) {
      const [upFactor, upSuffix] = units[i - 1];
      return `${Math.round(abs / upFactor * 10) / 10}${upSuffix}`;
    }
    return `${rounded.toFixed(digits).replace(/\.0$/, "")}${suffix}`;
  }
  return String(Math.round(abs));
};
var withCurrencyAffixes = (numeric, currency) => {
  try {
    const parts = new Intl.NumberFormat("en", {
      style: "currency",
      currency,
      currencyDisplay: "symbol",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).formatToParts(0);
    let prefix = "";
    let suffix = "";
    let seenNumber = false;
    for (const part of parts) {
      if (part.type === "integer" || part.type === "group") {
        seenNumber = true;
      } else if (part.type === "decimal" || part.type === "fraction") {
      } else if (seenNumber) {
        suffix += part.value;
      } else {
        prefix += part.value;
      }
    }
    return `${prefix}${numeric}${suffix}`;
  } catch {
    return `${currency} ${numeric}`;
  }
};
var formatCurrency = (amount, currency, format = "long" /* Long */) => {
  const num = typeof amount === "string" ? parseFloat(amount) : amount;
  if (format === "short" /* Short */) {
    const sign = num < 0 ? "-" : "";
    return `${sign}${withCurrencyAffixes(compactNumber(Math.abs(num)), currency)}`;
  }
  if (format === "card" /* Card */) {
    const sign = num < 0 ? "-" : "";
    return `${sign}${withCurrencyAffixes(compactCardNumber(Math.abs(num)), currency)}`;
  }
  const digits = format === "whole" /* Whole */ ? 0 : 2;
  try {
    return new Intl.NumberFormat("en", {
      style: "currency",
      currency,
      currencyDisplay: "symbol",
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(num);
  } catch {
    return `${currency} ${num.toFixed(digits)}`;
  }
};
var formatCurrencyCompact = (amount, currency) => formatCurrency(amount, currency, "short" /* Short */);

export {
  AmountFormat,
  formatCurrency,
  formatCurrencyCompact
};
